import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cldr from 'utils/Cldr';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import Radio from '@strava/ui/Radio';

import { setMonthlyDuration, setYearlyDuration } from '../../../actions';

import styles from './index.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

function handleDurationChange(duration, onClickFunc) {
  trackV2({
    category: 'summit_upsell',
    page: 'cart',
    action: 'change_duration',
    properties: {
      duration
    }
  });

  onClickFunc();
}

export const DurationSelect = ({
  currency,
  disabled,
  duration,
  trialLength,
  handleSetYearlyDuration,
  handleSetMonthlyDuration,
  yearlyPercentOff,
  monthlyRecurringAmount,
  yearlyRecurringAmount
}) => (
  <div className={`${styles.durationSelect}`}>
    <label className={styles.durationOption} htmlFor="duration-yearly">
      <Radio
        id="duration-yearly"
        type="radio"
        name="duration"
        className={styles.radioButton}
        checked={duration === 'yearly'}
        disabled={disabled}
        onChange={() => handleDurationChange('yearly', handleSetYearlyDuration)}
        value="yearly"
      />
      <div className={`${styles.optionLabel} ${styles.borderBottom}`}>
        <div className={styles.optionLabelTop}>
          {I18n.t(`${I18nPrefix}.yearly`)}
          <span className={styles.yearlyPercentOff}>
            {I18n.t(`${I18nPrefix}.savings`, {
              percent: Math.round(yearlyPercentOff)
            })}
          </span>
        </div>
        <div className={styles.optionLabelBottom}>
          {I18n.t(`${I18nPrefix}.recurring_cost.yearly`, {
            days: trialLength,
            price: Cldr.formatCurrency(yearlyRecurringAmount, currency)
          })}
        </div>
      </div>
    </label>
    <label className={styles.durationOption} htmlFor="duration-monthly">
      <Radio
        id="duration-monthly"
        type="radio"
        name="duration"
        className={styles.radioButton}
        checked={duration === 'monthly'}
        disabled={disabled}
        onChange={() =>
          handleDurationChange('monthly', handleSetMonthlyDuration)
        }
        value="monthly"
      />
      <div className={styles.optionLabel}>
        <div className={styles.optionLabelTop}>
          {I18n.t(`${I18nPrefix}.monthly`)}
        </div>
        <div className={styles.optionLabelBottom}>
          {I18n.t(`${I18nPrefix}.recurring_cost.monthly`, {
            days: trialLength,
            price: Cldr.formatCurrency(monthlyRecurringAmount, currency)
          })}
        </div>
      </div>
    </label>
  </div>
);

DurationSelect.propTypes = {
  yearlyRecurringAmount: PropTypes.number.isRequired,
  monthlyRecurringAmount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  duration: PropTypes.string.isRequired,
  yearlyPercentOff: PropTypes.number.isRequired,
  handleSetMonthlyDuration: PropTypes.func.isRequired,
  handleSetYearlyDuration: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  trialLength: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
  yearlyRecurringAmount: state.products.yearly.recurringAmount,
  monthlyRecurringAmount: state.products.monthly.recurringAmount,
  disabled:
    state.checkout_submitting ||
    state.promo_code_submitting ||
    state.products.promotion.full,
  duration: state.duration,
  yearlyPercentOff: state.yearly_percent_off,
  currency: state.currency,
  trialLength: state.trialInfo.trialLength
});

export default connect(
  mapStateToProps,
  {
    handleSetMonthlyDuration: setMonthlyDuration,
    handleSetYearlyDuration: setYearlyDuration
  }
)(DurationSelect);
